import { EventAttendeesPanel } from "../../../components/admin/event-hub/EventAttendeesPanel";

export function AdminEventAttendeesPage() {
  return <EventAttendeesPanel />;
}
